var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FilterableSelect',{attrs:{"defaultPlaceholder":"Quincena","defaultValue":_vm.QuincenaSelected,"inheritedOptions":_vm.QuincenaList},on:{"updateValue":_vm.handleSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }